import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import SelectIdNameMultiple from "components/SelectIdNameMultiple";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import persistanceStore from "stores/persistanceStore";

/**
 * The options come from the credentials that actually carry a regex validation, so every value
 * offered here narrows the list to something rather than to nothing.
 */
const RegexValidationFilters = () => {
  const { formatMessage: t } = useIntl();
  const { licenseService } = useGlobalContext();
  const {
    regexValidationFilterLocationIds,
    regexValidationFilterProfessionIds,
    regexValidationFilterCredentialIds,
  } = persistanceStore.useState();

  const { data, isFetching } = useQuery(
    ["licenseService.getRegexValidationFilterOptions"],
    () => licenseService.getRegexValidationFilterOptions()
  );

  return (
    <Accordion sx={{ mb: 3 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{t({ id: "filtersLabel" })}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <SelectIdNameMultiple
              label={t({ id: "locationLabel" })}
              options={data?.data?.locations ?? []}
              loading={isFetching}
              variant="outlined"
              value={regexValidationFilterLocationIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.regexValidationFilterLocationIds = v;
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <SelectIdNameMultiple
              label={t({ id: "professionLabel" })}
              options={data?.data?.professions ?? []}
              loading={isFetching}
              variant="outlined"
              value={regexValidationFilterProfessionIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.regexValidationFilterProfessionIds = v;
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <SelectIdNameMultiple
              label={t({ id: "regexValidationCredentialsFilterLabel" })}
              options={data?.data?.credentials ?? []}
              loading={isFetching}
              variant="outlined"
              value={regexValidationFilterCredentialIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.regexValidationFilterCredentialIds = v;
                })
              }
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default RegexValidationFilters;
